import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'material-ui/Button';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, } from 'material-ui/Dialog';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import { CircularProgress } from 'material-ui/Progress';
import Input, { InputLabel } from 'material-ui/Input';
import Slide from 'material-ui/transitions/Slide';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import find from 'lodash/find'

import * as login from '../../actions/userdetails'
import * as toaster from '../../actions/toaster'
import * as regData from '../../../appConstants'

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

class ChangeRole extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: { role_id: '' },
            setValue: false,
            isFileUploadSet: false,
            isFileDetailsUpdateSet: false,
        };
    }
    handleChange = event => {
        // console.log('this.state', this.state)
        const data = Object.assign({}, this.state.data, { role_id: event.target.value });
        this.setState(Object.assign({}, this.state, { 'data': data }));
    }
    handleRequestClose = () => {
        this.props.closeDialog();
    };

    setData = () => {
        this.props.handleSetChangeRole();
        this.props.actions.changeRole(this.state.data.role_id)
        this.setState({ data: { role_id: this.state.data.role_id } })
    };

    render() {
        const { loginUser, userDetails } = this.props;
        let data = loginUser
        let result = null;

        // console.log('this.state', this.state)
        let message = null;
        if (userDetails && userDetails.CPStatus)
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        // else if (userDetails && userDetails.CPResult)
        // this.props.closeDialog();


        if (!this.state.setValue && loginUser && loginUser.data) {
            this.state.data.role_id = +loginUser.data.role_id;
            this.setState({ setValue: true });
            console.log('changePassword Popup1=>', this.state.data)
        }
        let _RoleList = null
        // console.log('AddRole TeamList', JSON.stringify(loginUser.roleList));
        // console.log('AddRole TeamList', committeeList)
        if (loginUser && loginUser.roleList && loginUser.roleList.length > 0) {
            _RoleList = loginUser.roleList.map(role => (
                <MenuItem key={role.role_id} value={role.role_id}
                    style={{ fontWeight: '500', }}>
                    {role.role_name}
                </MenuItem>
            ))
        }
        return (
            <div>
                <Dialog open={this.props.open} transition={Slide} onClose={this.handleRequestClose}>
                    <DialogTitle className="bg-primary">
                        <span className="text-white">Change Role</span>
                    </DialogTitle>
                    <DialogContent>
                        {message}
                        <div className="row p-4">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-12">
                                        {/* Select the Role to be Played */}Please Select the Role
                                    </div>
                                </div>
                                {this.state.data ?
                                    <div className="row">
                                        <div className="col-md-12">
                                            <FormControl className="w-100 mb-2 col-md-12">
                                                <InputLabel htmlFor="age-simple"></InputLabel> 
                                                <Select
                                                    value={this.state.data.role_id}
                                                    onChange={this.handleChange}
                                                    input={<Input id="age-simple" />}
                                                >
                                                    {_RoleList}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                    : null}
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleRequestClose} variant="raised" className="jr-btn bg-grey text-white">Cancel</Button>
                        <Button onClick={this.setData.bind(this)} variant="raised" className="jr-btn bg-primary text-white">Change</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = ({ loginUser, userDetails }) => {
    return { loginUser, userDetails }
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, login, toaster), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ChangeRole);


// WEBPACK FOOTER //
// ./components/UserInfo/changerole.js